import { create } from 'zustand'

// One-shot handoffs between surfaces: the Dossier says "new mission about this star" or
// "note about this star", navigates, and the destination consumes the seed exactly once.
interface PrefillState {
  missionGoal: string | null
  noteCapture: string | null
  setMissionGoal: (goal: string) => void
  setNoteCapture: (text: string) => void
  consumeMissionGoal: () => string | null
  consumeNoteCapture: () => string | null
}

export const usePrefill = create<PrefillState>((set, get) => ({
  missionGoal: null,
  noteCapture: null,
  setMissionGoal: (missionGoal) => set({ missionGoal }),
  setNoteCapture: (noteCapture) => set({ noteCapture }),
  consumeMissionGoal: () => {
    const goal = get().missionGoal
    if (goal !== null) set({ missionGoal: null })
    return goal
  },
  consumeNoteCapture: () => {
    const text = get().noteCapture
    if (text !== null) set({ noteCapture: null })
    return text
  },
}))
